var sliding = false;
$('.proxy').click(function(e) {
    if(!sliding){
        window.open($(this).find('a').attr('href'),$(this).find('a').attr('target'))
    }
});
$('.proxy-parent').click(function(e) {
    if(!sliding){
        window.open($(this).parent().find('a').attr('href'),$(this).parent().find('a').attr('target'))
    }
});
